import { render, staticRenderFns } from "./TeacherTeachingOfferings.vue?vue&type=template&id=72736ece&scoped=true&"
import script from "./TeacherTeachingOfferings.vue?vue&type=script&lang=js&"
export * from "./TeacherTeachingOfferings.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTeachingOfferings.vue?vue&type=style&index=0&id=72736ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72736ece",
  null
  
)

export default component.exports